import { LuminousGallery } from 'luminous-lightbox';
import './app/init';
import './app/tinymce';
import './app/activestorage';
import './app/forms';
import './app/tablesorter';
import './app/user_kinds';
import { $, $1, $$, $e, tap } from './app/utils';

// prevent contextmenu
document.body.addEventListener('contextmenu', (ev) => {
  if (ev.target.closest('.nocontextmenu')) ev.preventDefault();
});

// lightbox
tap($$('a[rel^=lightbox]'), async (lightboxes) => {
  if (!lightboxes.length) return;
  new Set([...lightboxes].map(({ rel }) => rel)).forEach((rel) => {
    const target = $$(`a[rel="${rel}"]`);
    console.log(`Setting up luminous-lightbox (${rel}) target=${target.length}`);
    new LuminousGallery(target, {}, { caption: (el) => el.title });
  });
});

// scroll
document.body.addEventListener('click', (ev) => {
  const a = ev.target.closest('a[href^="#"]');
  if (!a) return;

  ev.preventDefault();
  const href = a.getAttribute('href');
  const target = href === '#top' ? document.body : $(href.slice(1));
  if (!target) {
    console.error(`Cannot find ${href}`);
    return;
  }

  const top = target.getBoundingClientRect().top + window.scrollY;
  window.scrollTo({ top, behavior: 'smooth' });
});

// tabs
tap($1('[data-tab]'), () => {
  const activateTab = (el) => {
    const tab = $1(el.dataset.tab || el.getAttribute('href'));
    const cntr = tab.closest('.tabs');
    const tabs = cntr.querySelectorAll('.tab-content');
    tabs.forEach((e) => {
      e.disabled = true;
      if (!e.classList.contains('tab-visible')) e.hidden = true;
    });
    tab.hidden = tab.disabled = false;
  };
  document.body.addEventListener('change', (ev) => {
    const el = ev.target.closest('[data-tab]');
    if (el) activateTab(el);
  });
  $$('[data-tab]:checked').forEach((el) => activateTab(el));
});

// <select> jump
document.body.addEventListener('change', (ev) => {
  const el = ev.target.closest('select[data-change-jump]');
  if (el?.value) location.href = el.value;
});

// removes
document.body.addEventListener('click', (ev) => {
  const el = ev.target.closest('[data-remove]');
  if (!el) return;

  ev.preventDefault();
  ev.stopImmediatePropagation();
  el.closest(el.dataset.remove).remove();
});

// details
$$('details[data-load]').forEach((details) =>
  details.addEventListener('toggle', () => {
    if (details.dataset.loaded) return;
    const spinner = $e('div', {}, $e('i', { className: 'fas fa-spinner fa-spin' }), 'Loading...');
    details.dataset.loaded = '0';
    details.append(spinner);
    fetch(details.dataset.load)
      .then((res) => res.text())
      .then((html) => {
        spinner.remove();
        details.insertAdjacentHTML('beforeend', html);
        details.dataset.loaded = '1';
      });
  }),
);
